import React, {  useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT , LIMIT_PAGE} from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress'; 
import Container from '@mui/material/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer'; 
import TextField from '@mui/material/TextField'; 
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingArticle from 'pages/purchases/SortingTablesArticles'; 

const initialFiltersArticle= {
  "idFrom":"",
  "idTo":"",
  "titleesFrom":"",
  "titleesTo":"", 
  "titleenFrom":"",
  "titleenTo":"", 
  "owncodeFrom":"",
  "owncodeTo":"",
  "codeanFrom":"",
  "codeanTo":"",
  "barcodeFrom":"",
  "barcodeTo":""
};
 
const initialStateArticle = [{
   "id":0,
  "titlees":"",
  "titleen":"",
  "owncode":"",
  "codean":"",
  "barcode":"",
  "marca":"",
  "model":"",
  "location":"",
  "applytypesofsize":true,  
  "applycolor":true,  
  "applynumserial":true, 
  "isnewpiece":true,  
  "actualstock":0,
  "subsection_id":0,
  "subsection_namees":"",
  "subsection_nameen":"",
}];
        

const PurchaseDeliverySearchArticles = ({ showModalSearchArticles, setShowModalSearchArticles,setNewArticle}) => {
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const token = useSelector((state) => state.loginUser.token);   
  const [dataArticle, setDataArticle] = useState(initialStateArticle);
  const [isLoadingErrorArticle, setIsLoadingErrorArticle] = useState(false);
  const [isLoadingArticle, setIsLoadingArticle] = useState(false);  
  const [inputTextArticle, setInputTextArticle] = useState("");
  const [applyFiltersArticle, setApplyFiltersArticle]= useState(initialFiltersArticle);
  const [filtersArticle, setFiltersArticle]= useState(initialFiltersArticle);
  const [openEditFilterArticle,setOpenEditFilterArticle]= useState(false);
  const [errorsFiltersArticle, setErrorsFiltersArticle] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegArticle,setNumTotRegArticle]= useState(0);
  const [activeOffsetArticle, setActiveOffsetArticle]= useState(false);
  const [currencyOffsetArticle, setCurrencyOffsetArticle] = useState(0);
  const [rangeOffsetArticle, setRangeOffsetArticle] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const handleCloseDataEditArticle = () => {
    setDataArticle(initialStateArticle);
    setIsLoadingErrorArticle(false);
    dispatch(setLoading(false));
    setInputTextArticle("");
    setApplyFiltersArticle(initialFiltersArticle);
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(false);
    setErrorsFiltersArticle({});
    setNumTotRegFilter(0);
    setNumTotRegArticle(0);
    setActiveOffsetArticle(false);
    setCurrencyOffsetArticle(0);
    setRangeOffsetArticle([{}]); 
    setShowModalSearchArticles(false)
	};

  const toggleDrawerSearchArticles  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditArticle();
    }
  };

  let inputHandlerArticle = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextArticle(lowerCase);
  };

  const openEditFiltersArticle = () => {
    setFiltersArticle(applyFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const toggleDrawerFilterEditArticle = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditArticle();
    }
  };

  const handleCancelFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const handleChangeFilterEditArticle = (e) => {
    const { name, value } = e.target;
    setFiltersArticle(filtersArticle => ({
      ...filtersArticle,
      [name]: value
    }));
  };

  const handleBlurFilterEditArticle = (e) => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    handleChangeFilterEditArticle(e);
  };
 
  const handleSubmitFilterEditArticle = () => {
    setErrorsFiltersArticle(validateFormFilterArticle());
    if (Object.keys(errorsFiltersArticle).length === 0) {
      setApplyFiltersArticle(filtersArticle);
      setFiltersArticle(initialFiltersArticle);
      setErrorsFiltersArticle({});
      setOpenEditFilterArticle(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersArticle = () => {
    setErrorsFiltersArticle({});
    setFiltersArticle(initialFiltersArticle);
    setApplyFiltersArticle(initialFiltersArticle);
    setOpenEditFilterArticle(!openEditFilterArticle);
  };

  const validateFormFilterArticle = () => {
    let errorsFiltersArticle = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersArticle.idFrom!=="" & !regexNumber.test(filtersArticle.idFrom)) {
      errorsFiltersArticle.idFrom = 'Text_TextNoNumber';
    }
    if (filtersArticle.idTo!=="" & !regexNumber.test(filtersArticle.idTo)) {
      errorsFiltersArticle.idTo = 'Text_TextNoNumber';
    }
    if (filtersArticle.idFrom!=="" & !errorsFiltersArticle.idFrom!==undefined){
      if (filtersArticle.idTo!=="" & !errorsFiltersArticle.idTo!==undefined){
        if (parseInt(filtersArticle.idTo)<parseInt(filtersArticle.idFrom)){
          errorsFiltersArticle.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersArticle.titleesFrom)) {
      errorsFiltersArticle.titleesFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.titleesTo)) {
      errorsFiltersArticle.titleesTo = 'Text_TextNoValid';
    } 
    
    if (regexInvalidCharacters.test(filtersArticle.owncodeFrom)) {
      errorsFiltersArticle.owncodeFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.owncodeTo)) {
      errorsFiltersArticle.owncodeTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeanFrom)) {
      errorsFiltersArticle.codeanFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.codeanTo)) {
      errorsFiltersArticle.codeanTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersArticle.barcodeFrom)) {
      errorsFiltersArticle.barcodeFrom = 'Text_TextNoValid';
    } 
     if (regexInvalidCharacters.test(filtersArticle.barcodeTo)) {
      errorsFiltersArticle.barcodeTo = 'Text_TextNoValid';
    } 

    if (filtersArticle.titleesTo!=="" & filtersArticle.titleesTo<filtersArticle.titleesFrom){
      errorsFiltersArticle.titleesTo = 'Text_TextGreater_title';
    }

    if (filtersArticle.owncodeTo!=="" & filtersArticle.owncodeTo<filtersArticle.codeanFrom){
      errorsFiltersArticle.owncodeTo = 'Text_TextGreater_owncode';
    }

    if (filtersArticle.codeanTo!=="" & filtersArticle.codeanTo<filtersArticle.codeanFrom){
      errorsFiltersArticle.codeanTo = 'Text_TextGreater_codean';
    }
    if (filtersArticle.barcodeTo!=="" & filtersArticle.codeLerTo<filtersArticle.barcodeFrom){
      errorsFiltersArticle.barcodeTo = 'Text_TextGreater_barcode';
    }
    return errorsFiltersArticle;
  }  

  const filteredDataArticle = dataArticle.filter((el) => {
    if (inputTextArticle === '') {
        return el;
    }
    else {
      let dataTranslate = 
       String(el.id || '') +
        String(el.titlees || '') +
        String(el.titleen || '') +
        String(el.owncode || '') +
        String(el.codean || '') +
        String(el.barcode || '');
      let result = dataTranslate.toLowerCase().includes(inputTextArticle.toLowerCase());
      return result;
    }
  })

  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegArticle = async () => {
      dispatch(setLoading(true));
      try { 
        const getData = await helpHttp().get(ENDPOINT, `purchasedelivery/getinformationtablearticles`, token);
        if (getData.err) {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post(ENDPOINT, `purchasedelivery/getcountfilterarticles`, token, applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };

    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT,`purchasedelivery/getarticles`,token,currencyOffsetArticle,LIMIT_PAGE,applyFiltersArticle);
        if (getData.err || getData.message === "Load failed") {
          setDataArticle(initialStateArticle);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
    
    if (showModalSearchArticles){
      fetchnumTotRegArticle();
      fetchnumTotRegFilter();
      fetchDataArticle(); 
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,applyFiltersArticle,currencyOffsetArticle,setIsLoadingArticle,showModalSearchArticles]);

  return(
    <>
      {showModalSearchArticles && 
        <div>
          <SwipeableDrawer
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchArticles(false)}
            onOpen={toggleDrawerSearchArticles(true)}>
            <Container >
              <Box sx={{ bgcolor: '#ffffff', width: '1150px'}}>
                <div id="myDIV">
                  <h1 className="h1NewStyle mb-2">
                  {isLoadingErrorArticle?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingArticle?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_ARTICLEs_Search')}</h1>
                    <div>
                      <button type="button" className="buttonCreate" onClick={handleCloseDataEditArticle}>{t('Button_Exit')}</button><> </>
                    </div> 
                </div>  
                <br/>
                <div className="searchStyle">
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextArticle}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                    placeholder={t('Text_Article_Search')} 
                    onChange={inputHandlerArticle}
                    fullWidth
                    label={t('Text_Article_Search')}>
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV">
                  <h1 className="filter-title">{t('Text_Filter')}</h1>
                  <div className="filter-buttons">
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersArticle}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersArticle.idFrom!=="" || applyFiltersArticle.idTo!=="")?"#32CD32":"#FFFFFF"}}></i>&nbsp;&nbsp;{t('Text_Code').toUpperCase()}</button><> </>
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersArticle}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersArticle.titleesFrom!=="" || applyFiltersArticle.titleesTo!=="" || applyFiltersArticle.titleenFrom!=="" || applyFiltersArticle.titleenTo!=="")?"#32CD32":"#FFFFFF"}}></i>&nbsp;&nbsp;{t('Text_Description').toUpperCase()}</button><> </>   
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersArticle}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersArticle.owncodeFrom!=="" || applyFiltersArticle.owncodeTo!=="")?"#32CD32":"#FFFFFF"}}></i>&nbsp;&nbsp;{t('Text_Owncode').toUpperCase()}</button><> </>
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersArticle}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersArticle.codeanFrom!=="" || applyFiltersArticle.codeanTo!=="")?"#32CD32":"#FFFFFF"}}></i>&nbsp;&nbsp;{t('Text_Codean').toUpperCase()}</button><> </>
                    <button type="button" className="buttonFilterHigh" onClick={openEditFiltersArticle}><i className="fas fa-solid fa-circle" style={{color:(applyFiltersArticle.barcodeFrom!=="" || applyFiltersArticle.barcodeTo!=="")?"#32CD32":"#FFFFFF"}}></i>&nbsp;&nbsp;{t('Text_Barcode').toUpperCase()}</button><> </>
                  </div>
                </div>
                <br/>
                {!isLoadingArticle ?
                  <>
                    <div className="card shadow mb-4">    
                      <div className="card-body">
                        <TableSortingArticle
                          dataArticle={filteredDataArticle}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={t('Text_ARTICLE_Table')}
                          numTotRegArticle={numTotRegArticle}
                          activeOffsetArticle={activeOffsetArticle}
                          rangeOffsetArticle={rangeOffsetArticle}
                          currencyOffsetArticle={currencyOffsetArticle}
                          setCurrencyOffsetArticle={setCurrencyOffsetArticle}                         
                          setNewArticle={setNewArticle}
                          handleCloseDataEditArticle={handleCloseDataEditArticle}
                        >
                        </TableSortingArticle>
                      </div>             
                    </div>
                    {openEditFilterArticle &&
                      <div>
                      <SwipeableDrawer
                        anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditArticle(false)}
                        onOpen={toggleDrawerFilterEditArticle(true)}>
                        <Container >
                          <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '1100' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form className="newfilterformstore" onSubmit={handleCancelFiltersArticle}>  
                                <div className="form-floating mb-3 px-4 primary">
                                    <div className="form-group">
                                    <TextField
                                      id="idFrom" 
                                      name="idFrom"
                                      value={filtersArticle.idFrom}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.idFrom!=null?t(errorsFiltersArticle.idFrom):t('Text_Filter_Code_From')}
                                      placeholder={t('PlaceHolder_Filter_Code_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                      <TextField
                                      id="idTo" 
                                      name="idTo"
                                      value={filtersArticle.idTo}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.idTo!=null?t(errorsFiltersArticle.idTo):t('Text_Filter_Code_To')}
                                      placeholder={t('PlaceHolder_Filter_Code_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                   <div className="form-group">
                                    <TextField
                                      id={i18n.language==="es"?"titleesFrom":"titleenFrom"}
                                      name={i18n.language==="es"?"titleesFrom":"titleenFrom"}
                                      value={i18n.language==="es"?filtersArticle.titleesFrom:filtersArticle.titleenFrom}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={i18n.language==="es"?errorsFiltersArticle.titleesFrom!=null?t(errorsFiltersArticle.titleesFrom):t('Text_Filter_titleFrom'):errorsFiltersArticle.titleenFrom!=null?t(errorsFiltersArticle.titleenFrom):t('PlaceHolder_Filter_titleFrom')}
                                      placeholder={t('PlaceHolder_Filter_titleFrom')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id={i18n.language==="es"?"titleesTo":"titleenTo"}
                                      name={i18n.language==="es"?"titleesTo":"titleenTo"}
                                      value={i18n.language==="es"?filtersArticle.titleesTo:filtersArticle.titleenTo}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={i18n.language==="es"?errorsFiltersArticle.titleesTo!=null?t(errorsFiltersArticle.titleesTo):t('Text_Filter_titleTo'):errorsFiltersArticle.titleenTo!=null?t(errorsFiltersArticle.titleenTo):t('PlaceHolder_Filter_titleTo')}
                                      placeholder={t('PlaceHolder_Filter_titleTo')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="owncodeFrom" 
                                      name="owncodeFrom"
                                      value={filtersArticle.owncodeFrom}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.owncodeFrom!=null?t(errorsFiltersArticle.owncodeFrom):t('Text_Filter_owncodeFrom')}
                                      placeholder={t('PlaceHolder_Filter_owncodeFrom')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                    <TextField
                                      id="owncodeTo" 
                                      name="owncodeTo"
                                      value={filtersArticle.owncodeTo}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.owncodeTo!=null?t(errorsFiltersArticle.owncodeTo):t('Text_Filter_owncodeTo')}
                                      placeholder={t('PlaceHolder_Filter_owncodeTo')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="codeanFrom" 
                                      name="codeanFrom"
                                      value={filtersArticle.codeanFrom}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.codeanFrom!=null?t(errorsFiltersArticle.codeanFrom):t('Text_Filter_codeanFrom')}
                                      placeholder={t('PlaceHolder_Filter_codeanFrom')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="codeanTo" 
                                      name="codeanTo"
                                      value={filtersArticle.codeanTo}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.codeanTo!=null?t(errorsFiltersArticle.codeanTo):t('Text_Filter_codeanTo')}
                                      placeholder={t('PlaceHolder_Filter_codeanTo')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                  <div className="form-group">
                                    <TextField
                                      id="barcodeFrom" 
                                      name="barcodeFrom"
                                      value={filtersArticle.barcodeFrom}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.barcodeFrom!=null?t(errorsFiltersArticle.barcodeFrom):t('Text_Filter_barcodeFrom')}
                                      placeholder={t('PlaceHolder_Filter_barcodeFrom')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleBlurFilterEditArticle}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <TextField
                                      id="barcodeTo" 
                                      name="barcodeTo"
                                      value={filtersArticle.barcodeTo}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      inputProps={{ style: {width: 400, fontSize: '18px' }, maxLength: 100, }}
                                      label={errorsFiltersArticle.barcodeTo!=null?t(errorsFiltersArticle.barcodeTo):t('Text_Filter_barcodeTo')}
                                      placeholder={t('PlaceHolder_Filter_barcodeTo')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditArticle}
                                      onChange={handleChangeFilterEditArticle}/>
                                  </div>
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="btn-group d-grid d-md-flex justify-content-md-end" role="group">
                                  <button className="btn btn-primary btn-lg custom-btn" type="button" onClick={handleSubmitFilterEditArticle}>{t('Button_Apply')}</button><> </>
                                  <button className="btn btn-outline-secondary btn-lg custom-btn" type="button" onClick={handleDeleteFiltersArticle}>{t('Button_Cancel_Filters')}</button>
                                </div>
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>
                }
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

PurchaseDeliverySearchArticles.propTypes = {
  showModalSearchArticles: PropTypes.bool.isRequired,
  setShowModalSearchArticles: PropTypes.func.isRequired,
  setNewArticle: PropTypes.func.isRequired
};

export default PurchaseDeliverySearchArticles;

